module.exports = __webpack_public_path__ + "static/img/partner_XXIV.a55812d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XXIV.png
// module id = rswd
// module chunks = 9